import React from 'react';
import { useSelector } from 'react-redux';

import VoiceSelectionModalPresentationV2 from './VoiceSelectionModalPresentationV2';

import type { VoiceSelectionModalContext } from 'js/src/data/modals';
import { getModalContext, isAIVoiceSelectionModalShowing } from 'js/src/data/modals';

const VoiceSelectionModal = () => {
    const isShowing = useSelector(isAIVoiceSelectionModalShowing);
    const modalContext = useSelector(getModalContext<VoiceSelectionModalContext>);

    const source = modalContext?.get('source');
    const initialSelectedVoiceId = modalContext?.get('initialSelectedVoiceId');
    const initialVoiceSpeed = modalContext?.get('initialVoiceSpeed', 1);
    const onRemoveVoiceover = modalContext?.toJS()['onRemoveVoiceover'];
    const onApply = modalContext?.toJS()['onApply'];
    const onBack = modalContext?.toJS()['onBack'];

    return (
        <VoiceSelectionModalPresentationV2
            source={source}
            isShowing={isShowing}
            initialSelectedVoiceId={initialSelectedVoiceId}
            initialVoiceSpeed={initialVoiceSpeed}
            onRemoveVoiceover={onRemoveVoiceover}
            onApply={onApply}
            onBack={onBack}
        />
    );
};
export default VoiceSelectionModal;
